export default "__VITE_ASSET__BwgI3KHO__"